import { FC } from 'react';
import { Modal, ModalOverlay } from '@chakra-ui/react';
import { EditHookReturnType } from '../../types';
import { REGISTRATION_STEP } from '../../../../../constants/registrationStep';
import { ComponentRegistrationInputModalView } from './ComponentRegistrationInputModalView';
import { ComponentRegistrationConfirmModalView } from './ComponentRegistrationConfirmModalView';
import { ComponentRegistrationResultModalView } from './ComponentRegistrationResultModalView';

type ComponentRegistrationModalViewProps = EditHookReturnType;

export const ComponentRegistrationModalView: FC<
  ComponentRegistrationModalViewProps
> = ({
  isOpenModal,
  onCloseModal,
  onCloseModalWhenCompleted,
  currentModalStep,
  form,
  values,
  onConfirm,
  onGoBack,
  onSubmit,
  onOpenModalDelete,
  mode,
  onAppend,
  onRemove,
  controlledFields,
}: ComponentRegistrationModalViewProps) => (
  <Modal
    isOpen={isOpenModal}
    onClose={onCloseModal}
    size="4xl"
    blockScrollOnMount
    closeOnOverlayClick={false}
    closeOnEsc={false}
  >
    <ModalOverlay />
    {currentModalStep === REGISTRATION_STEP.INPUT && (
      <ComponentRegistrationInputModalView
        mode={mode}
        {...form}
        handleConfirm={onConfirm}
        onOpenModalDelete={onOpenModalDelete}
        onAppend={onAppend}
        onRemove={onRemove}
        controlledFields={controlledFields}
      />
    )}
    {currentModalStep === REGISTRATION_STEP.CONFIRMATION && (
      <ComponentRegistrationConfirmModalView
        mode={mode}
        values={values}
        handleBack={onGoBack}
        handleSubmit={onSubmit}
      />
    )}
    {currentModalStep === REGISTRATION_STEP.RESULT && (
      <ComponentRegistrationResultModalView
        mode={mode}
        values={values}
        handleClose={onCloseModalWhenCompleted}
      />
    )}
  </Modal>
);
